// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__G147k","linkContainer":"Footer_linkContainer__CAp+Y"};